import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-db29dacc")

_pushScopeId("data-v-db29dacc")
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "search-area" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("过滤书籍")
const _hoisted_5 = {
  class: "infinite-list-wrapper",
  style: {"overflow":"auto"}
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  class: "infinite-list-wrapper",
  style: {"overflow":"auto"}
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "flex-1 w-full margin-left-10 editor-wrapper relative" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_13 = { class: "books-filter" }
const _hoisted_14 = /*#__PURE__*/_createVNode("strong", null, "全选: ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_search_input = _resolveComponent("search-input")
  const _component_paragraph_card = _resolveComponent("paragraph-card")
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")
  const _component_words_card = _resolveComponent("words-card")
  const _component_el_tabs = _resolveComponent("el-tabs")
  const _component_rich_text_editor = _resolveComponent("rich-text-editor")
  const _component_words_form = _resolveComponent("words-form")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")
  const _component_el_drawer = _resolveComponent("el-drawer")
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_el_button, {
            type: "warning",
            onClick: _ctx.filterBooks
          }, {
            default: _withId(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_search_input, {
            modelValue: _ctx.keyword,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.keyword = $event)),
            class: "flex-1 margin-left-10",
            onSearch: _ctx.handleSearch
          }, null, 8, ["modelValue", "onSearch"])
        ]),
        _createVNode(_component_el_tabs, {
          class: "margin-top-10",
          type: "border-card",
          modelValue: _ctx.activeTab,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeTab = $event))
        }, {
          default: _withId(() => [
            _createVNode(_component_el_tab_pane, {
              label: "原文库",
              name: "paragraph"
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_5, [
                  _withDirectives(_createVNode("ul", {
                    class: "list",
                    "infinite-scroll-disabled": _ctx.disabled
                  }, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.paragraphList, (paragraph) => {
                      return (_openBlock(), _createBlock("li", {
                        key: paragraph.id,
                        class: "list-item"
                      }, [
                        _createVNode(_component_paragraph_card, {
                          paragraph: paragraph,
                          onReference: _ctx.handleReference
                        }, null, 8, ["paragraph", "onReference"])
                      ]))
                    }), 128))
                  ], 8, ["infinite-scroll-disabled"]), [
                    [_directive_infinite_scroll, _ctx.loadMore]
                  ]),
                  (_ctx.loading)
                    ? (_openBlock(), _createBlock("p", _hoisted_6, "加载中..."))
                    : _createCommentVNode("", true),
                  (_ctx.noMore && _ctx.pageNum > 1)
                    ? (_openBlock(), _createBlock("p", _hoisted_7, "没有更多了"))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, {
              label: "文案库",
              name: "words"
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_8, [
                  _withDirectives(_createVNode("ul", {
                    class: "list",
                    "infinite-scroll-disabled": _ctx.disabled
                  }, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.wordsList, (words) => {
                      return (_openBlock(), _createBlock("li", {
                        key: words.id,
                        class: "list-item"
                      }, [
                        _createVNode(_component_words_card, {
                          words: words,
                          onReference: _ctx.handleReference
                        }, null, 8, ["words", "onReference"])
                      ]))
                    }), 128))
                  ], 8, ["infinite-scroll-disabled"]), [
                    [_directive_infinite_scroll, _ctx.loadMore]
                  ]),
                  (_ctx.loading)
                    ? (_openBlock(), _createBlock("p", _hoisted_9, "加载中..."))
                    : _createCommentVNode("", true),
                  (_ctx.noMore && _ctx.pageNum > 1)
                    ? (_openBlock(), _createBlock("p", _hoisted_10, "没有更多了"))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_11, [
        _createVNode(_component_rich_text_editor, {
          initContent: _ctx.initContent,
          modelValue: _ctx.currentContent,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.currentContent = $event)),
          class: "editor",
          ref: "editor"
        }, null, 8, ["initContent", "modelValue"]),
        _createVNode(_component_el_button, {
          type: "primary",
          class: "buttons",
          onClick: _ctx.saveWord
        }, {
          default: _withId(() => [
            _hoisted_12
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      title: "保存文案",
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.dialogVisible = $event)),
      width: "40%"
    }, {
      default: _withId(() => [
        _createVNode(_component_words_form, {
          words: _ctx.words,
          onCancel: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dialogVisible = false)),
          onSuccess: _ctx.wordsUpdated
        }, null, 8, ["words", "onSuccess"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_drawer, {
      title: "筛选书籍",
      modelValue: _ctx.booksFilterVisible,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.booksFilterVisible = $event)),
      direction: "ltr",
      "before-close": _ctx.beforeFilterClose,
      "destroy-on-close": ""
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_13, [
          _hoisted_14,
          _createVNode(_component_el_checkbox, {
            modelValue: _ctx.allSelected,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.allSelected = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_el_checkbox_group, {
            class: "margin-top-10",
            modelValue: _ctx.selectedBooks,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectedBooks = $event))
          }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.books, (book) => {
                return (_openBlock(), _createBlock(_component_el_checkbox, {
                  class: "block",
                  key: book.id,
                  label: book.id
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(book.title), 1)
                  ]),
                  _: 2
                }, 1032, ["label"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"])
  ], 64))
})